import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Suspense, lazy, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { track } from "@/lib/track";
import Landing from "@/pages/Landing";

const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const DeleteAccount = lazy(() => import("@/pages/DeleteAccount"));
const Ab2801 = lazy(() => import("@/pages/guides/Ab2801"));
const MoveInChecklist = lazy(() => import("@/pages/guides/MoveInChecklist"));
const DepositDisputes = lazy(() => import("@/pages/guides/DepositDisputes"));
const VsCameraRoll = lazy(() => import("@/pages/guides/VsCameraRoll"));
const AdminPage = lazy(() => import("@/pages/admin/AdminPage"));
const SignRedirect = lazy(() => import("@/pages/redirects").then((m) => ({ default: m.SignRedirect })));
const VerifyRedirect = lazy(() => import("@/pages/redirects").then((m) => ({ default: m.VerifyRedirect })));
const AuthCallback = lazy(() => import("@/pages/redirects").then((m) => ({ default: m.AuthCallback })));

const NO_TRACK_PREFIXES = ["/admin", "/sign", "/verify", "/auth-callback"];

const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (NO_TRACK_PREFIXES.some((p) => location.pathname.startsWith(p))) return;
    track("pageview", { path: location.pathname });
  }, [location.pathname]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <PageTracker />
          <Suspense fallback={<div className="min-h-screen bg-[#F7F6F2]" />}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="/ab-2801" element={<Ab2801 />} />
              <Route path="/move-in-checklist" element={<MoveInChecklist />} />
              <Route path="/security-deposit-disputes" element={<DepositDisputes />} />
              <Route path="/vs-camera-roll" element={<VsCameraRoll />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/sign/:token" element={<SignRedirect />} />
              <Route path="/verify/:reportId" element={<VerifyRedirect />} />
              <Route path="/auth-callback" element={<AuthCallback />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
